import React, { useState, useContext } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { AppStateContext } from "../Contexts/AppStateContext";
import { amber, green } from "@material-ui/core/colors";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  message: {
    display: "flex",
    alignItems: "center"
  },
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  }
}));

const Snack = props => {
  const { snackOpen, setSnackOpen, variant, message, ...other } = props;
  const classes = useStyles();
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      autoHideDuration={6000}
      onClose={() => setSnackOpen(false)}
      open={snackOpen}
    >
      <SnackbarContent
        aria-describedby="client-snackbar"
        open={snackOpen}
        className={clsx(classes[variant])}
        message={
          <span className={classes.message}>
            <CheckCircleIcon />
            {message}
          </span>
        }
        action={[
          <IconButton key="close" aria-label="close" color="inherit" onClick={() => setSnackOpen(false)}>
            <CloseIcon />
          </IconButton>
        ]}
      />
    </Snackbar>
  );
};

export default Snack;
